var parentStep = 1;
var clickTimer;
// radio
$('body').on('click', '.stepItem input[type="radio"]', function() {
    var $DHTO = $('#DHTO');
    parentStep = parseInt($(this).closest('.quizContBox').attr('data-step'));
    var parentNextStep = parentStep + 1;
    var stepValue = $(this).val();
    if (parentStep == 1) {
        $DHTO.attr('data-step1', stepValue);
    }
    if (parentStep == 2) {
        $DHTO.attr('data-step2', stepValue);
    }
    clearTimeout(clickTimer);
    clickTimer = setTimeout(function() {
      $DHTO.attr('data-step', parentNextStep);
    }, 300);  
});
// checkbox
$('body').on('click', '.stepItem input[type="checkbox"]', function() {
  var checkedCount = $(this).closest('.quizCont').find('input:checked').length;
  console.log(checkedCount);
  if (checkedCount == 0) {
    $(this).closest('.quizCont').find('.submitSelect').hide();  
  } else {
    $(this).closest('.quizCont').find('.submitSelect').show();  
  }
});  
$('body').on('click', '.quizHeader .back-btn', function() {
    parentStep = parseInt($(this).closest('.quizContBox').attr('data-step')) - 1;
    $('#DHTO').attr('data-step', parentStep);
});
$('body').on('click', '.quizClose', function(event) {
  $('body').removeClass('quizOpen');
  return false;
});
// calculate quiz
var clickTimer;
var redirectTimer;
var resultURL = '';
var universalArr = -1; 
$('body').on('click', '.submitSelect', function() {
  var quizCont = $(this).closest('.quizCont');
  var selectedVal = quizCont.find('input:checkbox:checked').map(function(){
    return $('#DHTO').attr('sport_prefix')+$(this).val();
  }).get();  

  $('#DHTO').attr('data-step3', selectedVal.toString());
  universalArr = $.inArray('Sport_Universal', selectedVal);

  var sizeAttr = '?'+$('#DHTO').attr('size_filter')+'='+$('#DHTO').attr('size_prefix')+$('#DHTO').attr('data-step2');
  var sportAttr = '&'+$('#DHTO').attr('sport_filter')+'='+$('#DHTO').attr('data-step3');
  if (universalArr > -1) {
    sportAttr = '';
  }
  var timeout = parseInt($('#DHTO').attr('data-result-timeout'));
  var templateName = '';
  if ($('#DHTO').attr('template-name') != '') {
    templateName = '&view='+$('#DHTO').attr('template-name');
  }
  resultURL = $('#DHTO').attr('data-root-url')+sizeAttr+sportAttr+templateName
  $('#DHTO').attr('quiz-result', resultURL); 
  //alert(resultURL) 
  
  clearTimeout(clickTimer);
  clickTimer = setTimeout(function() {
    $('#DHTO').attr('data-step', 4); 

    clearTimeout(redirectTimer);
    redirectTimer = setTimeout(function() {
      //console.log(resultURL);
      window.location.href = resultURL;
    }, timeout);   
  }, 300);     
  
});
// redirect click
$('body').on('click', '.submitRedirect', function(event) {
  //console.log(resultURL);
  window.location.href = resultURL;
});

